import { render, staticRenderFns } from "./component.vue?vue&type=template&id=86cbd5da&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./component.scss?vue&type=style&index=0&id=86cbd5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cbd5da",
  null
  
)

export default component.exports